import React, { FC, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Location } from 'history';
import { Button, Form, Input, Row, notification } from 'antd';

import { ErrorBoundary } from '@app/common';
import { useAuthStore } from '../hooks';
import { LoginParams } from '@app/modules/Auth';
import { config } from '@app/utils';
import { GlobalFooter } from '@app/common/GlobalFooter';
import { Loader } from '@app/common/Loader';
import { PATH } from '@app/constants';

import '../index.less';
import './Login.less';

const initialValues: LoginParams = {
  username: '',
  password: ''
  // remember: true
};

const Login: FC = () => {
  const navigate = useNavigate();
  const location = useLocation() as Location & { state: { from: string } };
  const { isUserLoggedIn, login, loadingAuthState, setLocale } = useAuthStore();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (isUserLoggedIn) {
      navigate(PATH.DASHBOARD);
      notification.info({
        message: "You've already logged in"
      });
    }
    console.log('WITHOUT DEPS', isUserLoggedIn);
  }, [loadingAuthState]);

  useEffect(() => {
    if (isUserLoggedIn) {
      navigate(PATH.DASHBOARD);
    }
    console.log('isUserLoggedIn DEPS', isUserLoggedIn);
  }, [isUserLoggedIn]);

  const onFinished = async (form: LoginParams) => {
    try {
      setLoading(true);
      await login(form);
      navigate(location.state?.from || { pathname: PATH.DASHBOARD });
    } catch (error) {
      notification.warn({
        message: 'Incorrect login',
        description: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  let footerLinks: any[] = [];

  if (config.i18n) {
    footerLinks = footerLinks.concat(
      config.i18n.languages.map(item => ({
        key: item.key,
        title: <span onClick={setLocale.bind(null, item.key)}>{item.title}</span>
      }))
    );
  }

  if (loadingAuthState) {
    return <Loader fullScreen spinning />;
  }

  return (
    <ErrorBoundary>
      <div className="form">
        <div className="logo">
          <img alt="logo" src={config.logoPath} />
          <span>{config.siteName}</span>
        </div>
        <Form onFinish={onFinished} initialValues={initialValues}>
          <Form.Item name="username" rules={[{ required: true, message: 'Type your name' }]} hasFeedback>
            <Input placeholder="Username" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: 'Type your password' }]} hasFeedback>
            <Input type="password" placeholder="Password" />
          </Form.Item>
          {/*<Form.Item name="remember" valuePropName="checked">*/}
          {/*  <Checkbox>Remember</Checkbox>*/}
          {/*</Form.Item>*/}
          <Row>
            <Button type="primary" htmlType="submit" loading={loading}>
              Sign in
            </Button>
          </Row>
        </Form>
      </div>
      <div className="footer">
        <GlobalFooter links={footerLinks} copyright={config.copyright} />
      </div>
    </ErrorBoundary>
  );
};

export default observer(Login);
